import { createMediaSpec } from './media';
import { uuid } from '../../utils/uuid';
import { mediaInline as mediaInlineFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name mediaInline_node
 */

export const mediaInline = createMediaSpec(mediaInlineFactory({}).attrs, true);
export const mediaInlineWithLocalId = createMediaSpec({
  ...mediaInlineFactory({}).attrs,
  localId: {
    default: uuid.generate()
  }
}, true, true);